module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"title":"Strana nenalezena","body":"Požadovanou stránku nelze najít."},"de":{"title":"Seite nicht gefunden","body":"Die von Ihnen gewünschte Seite wurde nicht gefunden."},"es":{"title":"Página no encontrada","body":"La página que está solicitando no pudo ser encontrada."},"fr":{"title":"Page non trouvée","body":"La page demandée ne peut être trouvée."}}')
  delete Component.options._Ctor
}
